<template>
<v-menu v-if="me" offset-y open-on-hover>
  <template #activator="{ on, attrs }">
    <v-btn v-on="on" v-bind="attrs" text>
      {{ me.name }}
    </v-btn>
  </template>
  <v-list>
    <!-- TODO -->
    <v-list-item dense @click="underConstruction">
      <v-list-item-title>Settings</v-list-item-title>
    </v-list-item>
    <!-- TODO -->
    <v-list-item dense @click="showChangeDialog">
      <v-list-item-title>Change Password</v-list-item-title>
    </v-list-item>
    <v-list-item dense @click="logout">
      <v-list-item-title>Logout</v-list-item-title>
    </v-list-item>
  </v-list>
  <v-dialog v-model="changeDialog" :width="400">
    <v-card>
      <v-card-title>
        <span class="headline">Change Password</span>
      </v-card-title>

      <v-spacer />

      <v-card-text>
        <v-form>
          <v-container>
            <v-text-field label="Current Password" v-model="oldpass" type="password" />
            <v-text-field label="New Password" v-model="newpass" type="password" />
            <v-alert
              v-if="newpassError"
              type="error"
            >{{ newpassError }}</v-alert>
            <v-text-field label="Confirm New Password" v-model="confirmpass" type="password" />
            <v-alert
              v-if="confirmpassError"
              type="error"
            >{{ confirmpassError }}</v-alert>
          </v-container>
          <v-btn block color="warning" :disabled="!valid" :loading="loading" @click="change">Submit</v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-menu>
</template>

<script>
export default {
  name: "AccountMenu",
  data() {
    return {
      changeDialog: false,
      oldpass: '',
      newpass: '',
      confirmpass: '',
      loading: false,
    }
  },
  inject: ["httpClient", "snackbar"],
  computed: {
    me() {
      return this.$store.state.me
    },
    newpassError() {
      if (this.newpass && this.newpass == this.oldpass)
        return "Choose a different password"
      return ''
    },
    confirmpassError() {
      if (this.newpass && this.confirmpass && !this.newpass.startsWith(this.confirmpass))
        return "Passwords don't match"
      return ''
    },
    valid() {
      return this.oldpass && this.newpass && this.confirmpass
        && this.oldpass != this.newpass && this.newpass == this.confirmpass
    },
  },
  methods: {
    async logout() {
      await this.httpClient.logout()
      this.$window.location.reload()
    },
    showChangeDialog() {
      setTimeout(() => this.changeDialog = true, 0)
    },
    async change() {
      this.loading = true
      await this.httpClient.changePassword(this.oldpass, this.newpass, this.confirmpass)
      this.loading = false
      this.changeDialog = false
    },
    underConstruction() {
      this.snackbar("Under Construction", "info")
    },
  },
}
</script>
